import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { createOption } from '@mews-commander/ui';
import { orderByLabel } from '@mews-commander/form';
import { useCurrentEnterpriseTaxRateCodes } from '../../hooks';

export const useCurrentEnterpriseTaxRateOptions = () => {
    const currentEnterpriseTaxRates = useCurrentEnterpriseTaxRateCodes();

    return useMemo(
        () =>
            pipe(
                currentEnterpriseTaxRates,
                array.map((taxRate) =>
                    createOption({
                        value: taxRate.code,
                        label: taxRate.code,
                    })
                ),
                array.sort(orderByLabel)
            ),
        [currentEnterpriseTaxRates]
    );
};
